<div class="d-flex">
  <div class="header-btn-lg">
    <div class="widget-content p-0">
      <div class="widget-content-wrapper">
        <div class="widget-content-left">
          <div class="btn-group" ngbDropdown placement="bottom-right">
            <button
              type="button"
              class="btn btn-link p-0 me-2"
              ngbDropdownToggle
            >
              <span>
                <div
                  class="icon-wrapper user-icon icon-wrapper-alt rounded-circle"
                  id="icon-active"
                >
                  <img
                    width="42"
                    src="./assets/images/avatars/2.png"
                    alt=""
                    class="rounded-circle"
                  />
                </div>
              </span>
            </button>
            <div
              class="dropdown-menu-md"
              ngbDropdownMenu
              style="box-shadow: -14px 14px 10px rgb(135 135 135 / 50%)"
            >
              <div class="dropdown-menu-header">
                <div
                  class="dropdown-menu-header-inner bg-info"
                  style="background-color: #032d55 !important"
                >
                  <div class="menu-header-image opacity-2 dd-header-bg-6"></div>
                  <div class="menu-header-content text-left">
                    <div class="widget-content p-0">
                      <div class="widget-content-wrapper">
                        <div class="widget-content-left user-icon me-3">
                          <img
                            width="42"
                            src="./assets/images/avatars/2.png"
                            alt=""
                            class="rounded-circle"
                          />
                        </div>
                        <div class="text-start _tas-user-info">
                          <div class="widget-heading font-size-lg">
                            {{ logedInUser?.username }}
                          </div>
                          <div class="widget-subheading opacity-10">
                            {{ logedInUser?.email }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="scroll-area-xs profile-box">
                <ul class="nav flex-column">
                  <li class="nav-item">
                    <button
                      class="nav-link text-primary border-0 bg-transparent font-size-sm"
                      (click)="open(content)"
                    >
                      {{ "Left_Menu.CHANGE_PASSWORD" | translate }}
                    </button>
                  </li>
                  <li class="nav-item" *ngIf="activeLicense">
                    <button
                      class="nav-link text-primary border-0 bg-transparent font-size-sm"
                      (click)="viewActiveLicense()"
                    >
                      {{ "Form.ActiveLicense" | translate }}
                    </button>
                  </li>
                  <li class="nav-item" *ngIf="showLicenseManage">
                    <button
                      class="nav-link text-primary border-0 bg-transparent font-size-sm"
                      [routerLink]="['/page/add-renew-license']"
                      ngbTooltip="{{ 'Form.AddEditPlan' | translate }}"
                    >
                      {{ "Form.ADDPlan" | translate }}
                    </button>
                  </li>
                  <li class="nav-item" *ngIf="showLicenseManage">
                    <button
                      class="nav-link text-primary border-0 bg-transparent font-size-sm"
                      (click)="viewlistOfCompanies()"
                    >
                      {{ "Form.ListofC" | translate }}
                    </button>
                  </li>

                  <li class="nav-item">
                    <a
                      href=""
                      (click)="onLogout()"
                      class="nav-link font-size-sm"
                      >{{ "Left_Menu.Logout" | translate }}</a
                    >
                  </li>
                </ul>
              </div>
              <div class="widget-content-right me-2"></div>
            </div>
          </div>
        </div>
        <div class="widget-content-left ms-3 header-user-info d-none">
          <div class="widget-heading" *ngIf="logedInUser">
            {{ logedInUser.username }}
          </div>
          <div class="widget-subheading" *ngIf="logedInUser">
            {{ logedInUser.email }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      {{ "Left_Menu.CHANGE_PASSWORD" | translate }}
    </h4>
    <button
      class="btn bg-transparent text-dark close"
      style="font-size: 25px; border: none !important"
      (click)="modal.dismiss('Cross click')"
    >
      &times;
    </button>
  </div>
  <div class="modal-body">
    <div class="card-body pt-0 ps-1">
      <form [formGroup]="form" class="needs-validation" autocomplete="off">
        <div class="position-relative row form-group mb-1">
          <label for="old_password_id" class="col-sm-12 pe-0 col-form-label"
            >{{ "Form.OLDPASSWORD" | translate
            }}<span class="text-danger">*</span></label
          >
          <div class="col-sm-12">
            <input
              formControlName="oldPassword"
              name="oldPassword"
              id="old_password_id"
              autocomplete="off"
              placeholder="{{ 'Form.Placeholder.OLDPASSWORD' | translate }}"
              type="password"
              class="form-control"
              required
            />
            <div
              *ngIf="submitted && f.oldPassword.errors"
              class="invalid-feedback"
            >
              <div *ngIf="f.oldPassword.errors.required">
                {{ "Form.Error.OLDPASSWORD" | translate }}
              </div>
            </div>
          </div>
        </div>

        <div class="position-relative row form-group mb-1">
          <label for="password_id" class="col-sm-12 pe-0 col-form-label"
            >{{ "Form.NEWPASSWORD" | translate
            }}<span class="text-danger">*</span></label
          >
          <div class="col-sm-12">
            <input
              formControlName="password"
              name="password"
              id="password_id"
              autocomplete="off"
              placeholder="{{ 'Form.Placeholder.NEWPASSWORD' | translate }}"
              type="password"
              class="form-control"
              required
            />
            <div *ngIf="submitted && f.password.errors" class="text-danger">
              <ul>
                <div *ngIf="f.password.errors.required">
                  <li>
                    {{ "Form.Error.PASSWORD" | translate }}
                  </li>
                </div>
                <div *ngIf="f.password.errors.minlength">
                  <li>
                    {{ "Form.Error.PASSWORDError" | translate }}
                  </li>
                </div>
                <div *ngIf="f.password.errors.pattern">
                  <li>
                    {{ "Form.Error.InavlidPass" | translate }}
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>

        <div class="position-relative row form-group mb-1">
          <label for="confirm_password_id" class="col-sm-12 pe-0 col-form-label"
            >{{ "Form.CONFIRM_PASSWORD" | translate
            }}<span class="text-danger">*</span></label
          >
          <div class="col-sm-12">
            <input
              formControlName="confirmPassword"
              name="confirmPassword"
              autocomplete="off"
              id="confirm_password_id"
              placeholder="{{
                'Form.Placeholder.CONFIRM_PASSWORD' | translate
              }}"
              type="password"
              class="form-control"
              required
            />
            <div *ngIf="submitted && f.confirmPassword.errors">
              <ul>
                <div *ngIf="f.confirmPassword.errors.required">
                  <li>
                    {{ "Form.Error.CONFIRM_PASSWORD" | translate }}
                  </li>
                </div>
                <div *ngIf="f.confirmPassword.errors.match" class="text-danger">
                  <li>
                    {{ "Form.Error.CONFIRM_New_PASSWORD_Error" | translate }}
                  </li>
                </div>
              </ul>
            </div>
          </div>
        </div>

        <div class="position-relative row form-check">
          <div class="col-sm-10 offset-sm-2 mt-5">
            <button
              class="btn btn-primary"
              style="margin-right: 10px"
              type="submit"
              (click)="onSubmit()"
            >
              {{ "Form.SAVE" | translate }}
            </button>
            <button class="btn btn-secondary" (click)="onReset()">
              {{ "Form.CANCEL" | translate }}
            </button>
          </div>
        </div>
      </form>
      <!--  <div class="relevent-info mt-5 pe-3">
        <div class="">
          <h3 class="mb-4">{{ "Form.ADDITIONALINFO" | translate }}</h3>
          <p>{{ "Form.ADDITIONALINFOChangePassword" | translate }}</p>
        </div>
      </div> -->
    </div>
  </div>
</ng-template>
